import React, { useEffect } from "react";
// import { AuthData } from "../../auth/AuthWrapper"
import {API_SERVER_URL} from "../../utils/config_ip_details";
import login_bg from "../../assets/images/login_bg.svg"; // Adjust the 
import { useNavigate } from "react-router-dom";
import {PRODUCT_NAME} from "../../utils/config_mapping"
export const Login = () => {
     const navigate = useNavigate();
    //  const { login } = AuthData();
    //  const [ formData, setFormData ] = useReducer((formData, newItem) => { return ( {...formData, ...newItem} )}, {userName: "", password: ""})
    //  const [ errorMessage, setErrorMessage ] = useState(null)

    useEffect(() => {
        if (parseInt(localStorage.getItem("login")) === 1) {
          navigate("/overview");
        }
      }, [navigate]); // Ensure the effect runs only when `navigate` is stable
    
     return (
    <>
   <div className="min-h-screen flex items-center justify-center relative">
   <div class="bg-overlay"></div>
  <div className="shape">
            <img src={login_bg} />
          </div>

  <div className="relative z-10 container mx-auto px-4">
    <div className="flex justify-center items-center">
      {/* <img className="logo-img" src="your-logo-url" alt="Logo" /> */}
    </div>
    <div className="flex justify-center">
      <div className="bg-white p-8 rounded-2xl shadow-lg w-full max-w-md card-bg-fill">
        <div className="text-center mb-4">
          <h3 className="text-primary text-3xl font-bold mb-3">SpecAgent</h3>
          <h5 className="text-primary text-xl">Welcome Back!</h5>
        </div>
        <div className="mt-1">
          <form>
            <div className="flex justify-center items-center">
            <a
              href={`${API_SERVER_URL}login/`}
              className="bg-blue-800 hover:bg-blue-900 text-white font-bold py-2 px-4 rounded w-full text-center"
            >
              Login
            </a>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  </div>
    </>
     )
}